(function () {
  'use strict';

  /* @ngdoc object
   * @name labvalue
   * @description
   *
   */
  angular
    .module('labvalue', [
      'ui.router',
      'ngTagsInput',
      'ui.bootstrap.typeahead'
    ]);
}());
